import { createSlice } from "@reduxjs/toolkit";
import { produce } from 'immer';

import { ModalSliceState, StoreModal, StoreState } from "../../interfaces/store";

const initialState: ModalSliceState = {
    activeModals: []
};

const modalSlice = createSlice({
    name: "modals",
    initialState,
    reducers: {
        openModal: (state, action) => {
            const { name, data } = action.payload as StoreModal;
            const isModalActive = state.activeModals.findIndex(modal => modal.name === name) !== -1;

            return produce(state, draft => {
                if (!isModalActive) {
                    draft.activeModals.push({ name, data });
                }
            });
        },
        closeModal: (state, action) => {
            const name = action.payload;
            return produce(state, draft => {
                draft.activeModals = draft.activeModals.filter(modal => modal.name !== name);
            });
        },
        closeAllModals: (state) => {
            return produce(state, draft => {
                draft.activeModals = [];
            });
        }
    }
});

export const { openModal, closeModal, closeAllModals } = modalSlice.actions;
export default modalSlice.reducer;

// Selectors
export const getActiveModals = () => (state: StoreState) => state.modals.activeModals;
export const isModalActive = (name: string) => (state: StoreState) => {
    return state.modals.activeModals?.findIndex(modal => modal?.name === name) !== -1
};
export const getModalData = (name: string) => (state: StoreState) => {
    return state.modals.activeModals?.find(modal => modal?.name === name)?.data ?? null
};